import { Formik, Form, Field, ErrorMessage } from "formik";
import { useState,useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setStep, setmultiMemberLLCDataStep2 } from "../../../Reducers/legalTools/multiMemberLLCSlice";
import * as Yup from "yup";
const MultiMemberLLCFormStep2Schema = Yup.object().shape({
  allMemberAreParticipatingInTheManagement: Yup.string().required(
    "This field is required"
  ),
  nonManagingMemberStillBeProvidingServices: Yup.string().when(
    "allMemberAreParticipatingInTheManagement",
    {
      is: (allMemberAreParticipatingInTheManagement) =>
        allMemberAreParticipatingInTheManagement === "false",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  membersNotExpectedToHaveManagerAuthority: Yup.string().when(
    "allMemberAreParticipatingInTheManagement",
    {
      is: (allMemberAreParticipatingInTheManagement) =>
        allMemberAreParticipatingInTheManagement === "false",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  expectedTimeCommitment: Yup.array()
    .of(Yup.boolean())
    .test("atLeastOneChecked", "Please select at least one", (value) =>
      value.some((v) => v === true)
    ),
  otherEachMemberExpectedTimeCommitment: Yup.string().when(
    "expectedTimeCommitment",
    {
      is: (expectedTimeCommitment) => expectedTimeCommitment[3] === true,
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberGetSalary: Yup.string().required("This field is required"),
  otherMemberGetSalary: Yup.string().when("memberGetSalary", {
    is: (memberGetSalary) => memberGetSalary === "3",
    then: (schema) => schema.required("This field is required"),
  }),
  isCoMemberHaveApprovalRight: Yup.string().when(
    [
      "nonManagingMemberStillBeProvidingServices",
      "allMemberAreParticipatingInTheManagement",
    ],
    {
      is: (
        nonManagingMemberStillBeProvidingServices,
        allMemberAreParticipatingInTheManagement
      ) =>
        (allMemberAreParticipatingInTheManagement === "false" &&
          nonManagingMemberStillBeProvidingServices === "true") ||
        allMemberAreParticipatingInTheManagement === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  coMemberApprovalThreshold: Yup.string().when(
    [
      "nonManagingMemberStillBeProvidingServices",
      "allMemberAreParticipatingInTheManagement",
      "isCoMemberHaveApprovalRight",
    ],
    {
      is: (
        nonManagingMemberStillBeProvidingServices,
        allMemberAreParticipatingInTheManagement,
        isCoMemberHaveApprovalRight
      ) =>
        (allMemberAreParticipatingInTheManagement === "false" &&
          nonManagingMemberStillBeProvidingServices === "true" &&
          isCoMemberHaveApprovalRight === "true") ||
        (allMemberAreParticipatingInTheManagement === "true" &&
          isCoMemberHaveApprovalRight === "true"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  coMemberApproval: Yup.array()
    .of(Yup.boolean())
    .when(
      [
        "nonManagingMemberStillBeProvidingServices",
        "allMemberAreParticipatingInTheManagement",
        "isCoMemberHaveApprovalRight",
      ],
      {
        is: (
          nonManagingMemberStillBeProvidingServices,
          allMemberAreParticipatingInTheManagement,
          isCoMemberHaveApprovalRight
        ) =>
          (allMemberAreParticipatingInTheManagement === "false" &&
            nonManagingMemberStillBeProvidingServices === "true" &&
            isCoMemberHaveApprovalRight === "true") ||
          (allMemberAreParticipatingInTheManagement === "true" &&
            isCoMemberHaveApprovalRight === "true"),
        then: (schema) =>
          schema.test(
            "atLeastOneChecked",
            "Please select at least one",
            (value) => value.some((v) => v === true)
          ),
      }
    ),
  otherCoMemberApprovalRequiredTo: Yup.string().when(
    [
      "nonManagingMemberStillBeProvidingServices",
      "allMemberAreParticipatingInTheManagement",
      "isCoMemberHaveApprovalRight",
      "coMemberApproval",
    ],
    {
      is: (
        nonManagingMemberStillBeProvidingServices,
        allMemberAreParticipatingInTheManagement,
        isCoMemberHaveApprovalRight,
        coMemberApproval
      ) =>
        (allMemberAreParticipatingInTheManagement === "false" &&
          nonManagingMemberStillBeProvidingServices === "true" &&
          isCoMemberHaveApprovalRight === "true" &&
          coMemberApproval[15] === true) ||
        (allMemberAreParticipatingInTheManagement === "true" &&
          isCoMemberHaveApprovalRight === "true" &&
          coMemberApproval[15] === true),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  limitOnTransactionsBeforeCoMemberApprovalIsRequired: Yup.number().when(
    [
      "nonManagingMemberStillBeProvidingServices",
      "allMemberAreParticipatingInTheManagement",
      "isCoMemberHaveApprovalRight",
      "coMemberApproval",
    ],
    {
      is: (
        nonManagingMemberStillBeProvidingServices,
        allMemberAreParticipatingInTheManagement,
        isCoMemberHaveApprovalRight,
        coMemberApproval
      ) =>
        (allMemberAreParticipatingInTheManagement === "false" &&
          nonManagingMemberStillBeProvidingServices === "true" &&
          isCoMemberHaveApprovalRight === "true" &&
          coMemberApproval[0] === true) ||
        (allMemberAreParticipatingInTheManagement === "true" &&
          isCoMemberHaveApprovalRight === "true" &&
          coMemberApproval[0] === true),
      then: (schema) =>
        schema
          .typeError("Please enter a valid input")
          .required("This field is required"),
    }
  ),
  limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired:
    Yup.number().when(
      [
        "nonManagingMemberStillBeProvidingServices",
        "allMemberAreParticipatingInTheManagement",
        "isCoMemberHaveApprovalRight",
        "coMemberApproval",
      ],
      {
        is: (
          nonManagingMemberStillBeProvidingServices,
          allMemberAreParticipatingInTheManagement,
          isCoMemberHaveApprovalRight,
          coMemberApproval
        ) =>
          (allMemberAreParticipatingInTheManagement === "false" &&
            nonManagingMemberStillBeProvidingServices === "true" &&
            isCoMemberHaveApprovalRight === "true" &&
            coMemberApproval[1] === true) ||
          (allMemberAreParticipatingInTheManagement === "true" &&
            isCoMemberHaveApprovalRight === "true" &&
            coMemberApproval[1] === true),
        then: (schema) =>
          schema
            .typeError("Please enter a valid input")
            .required("This field is required"),
      }
    ),
  isIncludeManagementDeadlockProcedures: Yup.string().when(
    [
      "nonManagingMemberStillBeProvidingServices",
      "allMemberAreParticipatingInTheManagement",
      "isCoMemberHaveApprovalRight",
    ],
    {
      is: (
        nonManagingMemberStillBeProvidingServices,
        allMemberAreParticipatingInTheManagement,
        isCoMemberHaveApprovalRight
      ) =>
        (allMemberAreParticipatingInTheManagement === "false" &&
          nonManagingMemberStillBeProvidingServices === "true" &&
          isCoMemberHaveApprovalRight === "true") ||
        (allMemberAreParticipatingInTheManagement === "true" &&
          isCoMemberHaveApprovalRight === "true"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  deadlockVoteThreshold: Yup.string().when(
    [
      "allMemberAreParticipatingInTheManagement",
      "nonManagingMemberStillBeProvidingServices",
      "isCoMemberHaveApprovalRight",
      "isIncludeManagementDeadlockProcedures",
      "managementDeadlockResolutionYouLike",
    ],
    {
      is: (
        allMemberAreParticipatingInTheManagement,
        nonManagingMemberStillBeProvidingServices,
        isCoMemberHaveApprovalRight,
        isIncludeManagementDeadlockProcedures,
        managementDeadlockResolutionYouLike
      ) =>
        (allMemberAreParticipatingInTheManagement === "false" &&
          nonManagingMemberStillBeProvidingServices === "true" &&
          isCoMemberHaveApprovalRight === "true" &&
          isIncludeManagementDeadlockProcedures === "true" &&
          managementDeadlockResolutionYouLike === "2") ||
        (allMemberAreParticipatingInTheManagement === "true" &&
          isCoMemberHaveApprovalRight === "true" &&
          isIncludeManagementDeadlockProcedures === "true" &&
          managementDeadlockResolutionYouLike === "2"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  shouldMemberAbleToBeRemoved: Yup.string().required("This field is required"),
  voteThresholdYouWantToRemoveForCauseOrIncapacity: Yup.string().when(
    "shouldMemberAbleToBeRemoved",
    {
      is: (shouldMemberAbleToBeRemoved) => shouldMemberAbleToBeRemoved === "1",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherVoteThresholdYouWantToRemoveForCauseOrIncapacity: Yup.string().when(
    [
      "shouldMemberAbleToBeRemoved",
      "voteThresholdYouWantToRemoveForCauseOrIncapacity",
    ],
    {
      is: (
        shouldMemberAbleToBeRemoved,
        voteThresholdYouWantToRemoveForCauseOrIncapacity
      ) =>
        shouldMemberAbleToBeRemoved === "1" &&
        voteThresholdYouWantToRemoveForCauseOrIncapacity === "6",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  voteThresholdYouWantToRemoveWithoutCause: Yup.string().when(
    "shouldMemberAbleToBeRemoved",
    {
      is: (shouldMemberAbleToBeRemoved) => shouldMemberAbleToBeRemoved === "2",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherVoteThresholdYouWantToRemoveWithoutCause: Yup.string().when(
    ["shouldMemberAbleToBeRemoved", "voteThresholdYouWantToRemoveWithoutCause"],
    {
      is: (
        shouldMemberAbleToBeRemoved,
        voteThresholdYouWantToRemoveWithoutCause
      ) =>
        shouldMemberAbleToBeRemoved === "2" &&
        voteThresholdYouWantToRemoveWithoutCause === "5",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  shouldTheMemberUnitSubjectToRepurchase: Yup.string().required(
    "This field is required"
  ),
  howLongOfNoticePeriod: Yup.string().required("This field is required"),
  otherHowLongOfNoticePeriod: Yup.string().when("howLongOfNoticePeriod", {
    is: (howLongOfNoticePeriod) => howLongOfNoticePeriod === "5",
    then: (schema) => schema.required("This field is required"),
  }),
  isLikeToWaiveTheMemberFiduciaryDuties: Yup.string().required(
    "This field is required"
  ),
  isMemberSubjectToNonCompeteAgreement: Yup.string().required(
    "This field is required"
  ),
  monthsAfterMemberNoLongerWorkingForNonCompete: Yup.string().when(
    [
      "isMemberSubjectToNonCompeteAgreement",
      "isMemberSubjectToNonSolicitationAgreement",
    ],
    {
      is: (
        isMemberSubjectToNonCompeteAgreement,
        isMemberSubjectToNonSolicitationAgreement
      ) => {
        return (
          isMemberSubjectToNonCompeteAgreement === "true" &&
          isMemberSubjectToNonSolicitationAgreement === "false"
        );
      },
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherMonthsAfterMemberNoLongerWorkingForNonCompete: Yup.string().when(
    [
      "isMemberSubjectToNonCompeteAgreement",
      "isMemberSubjectToNonSolicitationAgreement",
      "monthsAfterMemberNoLongerWorkingForNonCompete",
    ],
    {
      is: (
        isMemberSubjectToNonCompeteAgreement,
        isMemberSubjectToNonSolicitationAgreement,
        monthsAfterMemberNoLongerWorkingForNonCompete
      ) =>
        isMemberSubjectToNonCompeteAgreement === "true" &&
        isMemberSubjectToNonSolicitationAgreement === "false" &&
        monthsAfterMemberNoLongerWorkingForNonCompete === "4",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  monthsAfterMemberNoLongerWorkingForNonSolicitation: Yup.string().when(
    [
      "isMemberSubjectToNonCompeteAgreement",
      "isMemberSubjectToNonSolicitationAgreement",
    ],
    {
      is: (
        isMemberSubjectToNonCompeteAgreement,
        isMemberSubjectToNonSolicitationAgreement
      ) =>
        isMemberSubjectToNonCompeteAgreement === "false" &&
        isMemberSubjectToNonSolicitationAgreement === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherMonthsAfterMemberNoLongerWorkingForNonSolicitation: Yup.string().when(
    [
      "isMemberSubjectToNonCompeteAgreement",
      "isMemberSubjectToNonSolicitationAgreement",
      "monthsAfterMemberNoLongerWorkingForNonSolicitation",
    ],
    {
      is: (
        isMemberSubjectToNonCompeteAgreement,
        isMemberSubjectToNonSolicitationAgreement,
        monthsAfterMemberNoLongerWorkingForNonSolicitation
      ) =>
        isMemberSubjectToNonCompeteAgreement === "false" &&
        isMemberSubjectToNonSolicitationAgreement === "true" &&
        monthsAfterMemberNoLongerWorkingForNonSolicitation === "4",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation:
    Yup.string().when(
      [
        "isMemberSubjectToNonCompeteAgreement",
        "isMemberSubjectToNonSolicitationAgreement",
      ],
      {
        is: (
          isMemberSubjectToNonCompeteAgreement,
          isMemberSubjectToNonSolicitationAgreement
        ) =>
          isMemberSubjectToNonCompeteAgreement === "true" &&
          isMemberSubjectToNonSolicitationAgreement === "true",
        then: (schema) => schema.required("This field is required"),
      }
    ),
  otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation:
    Yup.string().when(
      [
        "isMemberSubjectToNonCompeteAgreement",
        "isMemberSubjectToNonSolicitationAgreement",
        "monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation",
      ],
      {
        is: (
          isMemberSubjectToNonCompeteAgreement,
          isMemberSubjectToNonSolicitationAgreement,
          monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation
        ) =>
          isMemberSubjectToNonCompeteAgreement === "true" &&
          isMemberSubjectToNonSolicitationAgreement === "true" &&
          monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation ===
            "4",
        then: (schema) => schema.required("This field is required"),
      }
    ),
});
const MultiMemberLLCFormStep2 = () => {
  const dispatch = useDispatch();
  const multiMemberLLCData = useSelector((state) => state.multiMemberLLC.multiMemberLLCData);
  return (
    <>
      <Formik
        initialValues={{
          allMemberAreParticipatingInTheManagement: multiMemberLLCData.allMemberAreParticipatingInTheManagement,
          nonManagingMemberStillBeProvidingServices: multiMemberLLCData.nonManagingMemberStillBeProvidingServices,
          membersNotExpectedToHaveManagerAuthority: multiMemberLLCData.membersNotExpectedToHaveManagerAuthority,
          expectedTimeCommitment: [multiMemberLLCData.expectedTimeCommitment[0], multiMemberLLCData.expectedTimeCommitment[1], multiMemberLLCData.expectedTimeCommitment[2], multiMemberLLCData.expectedTimeCommitment[3]],
          otherEachMemberExpectedTimeCommitment: multiMemberLLCData.otherEachMemberExpectedTimeCommitment,
          memberGetSalary: multiMemberLLCData.memberGetSalary,
          otherMemberGetSalary: multiMemberLLCData.otherMemberGetSalary,
          isCoMemberHaveApprovalRight: multiMemberLLCData.isCoMemberHaveApprovalRight,
          coMemberApprovalThreshold: multiMemberLLCData.coMemberApprovalThreshold,
          coMemberApproval: [
            multiMemberLLCData.coMemberApproval[0],
            multiMemberLLCData.coMemberApproval[1],
            multiMemberLLCData.coMemberApproval[2],
            multiMemberLLCData.coMemberApproval[3],
            multiMemberLLCData.coMemberApproval[4],
            multiMemberLLCData.coMemberApproval[5],
            multiMemberLLCData.coMemberApproval[6],
            multiMemberLLCData.coMemberApproval[7],
            multiMemberLLCData.coMemberApproval[8],
            multiMemberLLCData.coMemberApproval[9],
            multiMemberLLCData.coMemberApproval[10],
            multiMemberLLCData.coMemberApproval[11],
            multiMemberLLCData.coMemberApproval[12],
            multiMemberLLCData.coMemberApproval[13],
            multiMemberLLCData.coMemberApproval[14],
            multiMemberLLCData.coMemberApproval[15],
          ],
          otherCoMemberApprovalRequiredTo: multiMemberLLCData.otherCoMemberApprovalRequiredTo,
          limitOnTransactionsBeforeCoMemberApprovalIsRequired: multiMemberLLCData.limitOnTransactionsBeforeCoMemberApprovalIsRequired,
          limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired:
            multiMemberLLCData.limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired,
          isIncludeManagementDeadlockProcedures: multiMemberLLCData.isIncludeManagementDeadlockProcedures,
          managementDeadlockResolutionYouLike: multiMemberLLCData.managementDeadlockResolutionYouLike,
          deadlockVoteThreshold: multiMemberLLCData.deadlockVoteThreshold,
          shouldMemberAbleToBeRemoved: multiMemberLLCData.shouldMemberAbleToBeRemoved,
          voteThresholdYouWantToRemoveForCauseOrIncapacity: multiMemberLLCData.voteThresholdYouWantToRemoveForCauseOrIncapacity,
          otherVoteThresholdYouWantToRemoveForCauseOrIncapacity: multiMemberLLCData.otherVoteThresholdYouWantToRemoveForCauseOrIncapacity,
          voteThresholdYouWantToRemoveWithoutCause: multiMemberLLCData.voteThresholdYouWantToRemoveWithoutCause,
          otherVoteThresholdYouWantToRemoveWithoutCause: multiMemberLLCData.otherVoteThresholdYouWantToRemoveWithoutCause,
          shouldTheMemberUnitSubjectToRepurchase: multiMemberLLCData.shouldTheMemberUnitSubjectToRepurchase,
          howLongOfNoticePeriod: multiMemberLLCData.howLongOfNoticePeriod,
          otherHowLongOfNoticePeriod: multiMemberLLCData.otherHowLongOfNoticePeriod,
          isLikeToWaiveTheMemberFiduciaryDuties: multiMemberLLCData.isLikeToWaiveTheMemberFiduciaryDuties,
          isMemberSubjectToNonCompeteAgreement: multiMemberLLCData.isMemberSubjectToNonCompeteAgreement,
          isMemberSubjectToNonSolicitationAgreement: multiMemberLLCData.isMemberSubjectToNonSolicitationAgreement,
          monthsAfterMemberNoLongerWorkingForNonCompete: multiMemberLLCData.monthsAfterMemberNoLongerWorkingForNonCompete,
          otherMonthsAfterMemberNoLongerWorkingForNonCompete: multiMemberLLCData.otherMonthsAfterMemberNoLongerWorkingForNonCompete,
          monthsAfterMemberNoLongerWorkingForNonSolicitation: multiMemberLLCData.monthsAfterMemberNoLongerWorkingForNonSolicitation,
          otherMonthsAfterMemberNoLongerWorkingForNonSolicitation: multiMemberLLCData.otherMonthsAfterMemberNoLongerWorkingForNonSolicitation,
          monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation: multiMemberLLCData.monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation,
          otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation:
            multiMemberLLCData.otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation,
        }}
        validationSchema={MultiMemberLLCFormStep2Schema}
        onSubmit={(values) => {
          console.log(values);
          window.scrollTo(0, 0);
          dispatch(setStep(3));
          dispatch(setmultiMemberLLCDataStep2(values))
        }}
      >
        {(formik) => (
          <Form>
            <div className="content-box mt-5">
              <h3 className="text-dark content-title">Management</h3>
              <p>
                <strong>Member-Managed LLCs:</strong> Our form of Operating
                Agreement for the LLC Builder uses a “member-managed” set-up.
                This means that each of the members are each responsible for the
                business and operations of the company. If it is not desired
                that a member have any rights to participate in the management
                of the company, then you may want to use a "manager"-managed
                LLC. This manager-managed set-up separates the role of owner
                (i.e. member) and manager. Use of this LLC Builder only allows
                for this set-up where the members are managers, but please
                contact us if a different arrangement is desired.
              </p>
              <p>
                We use the member-managed approach for the LLC Builder as most
                small business partnership are arranged this way. That is, where
                two or more business partners are all expected to be involved in
                running the business. If someone quits working for the company,
                then they stop being a member (key to remember, however, that
                they still may have some ownership rights-we address this issue
                in the form).
              </p>
              <p>
                <strong>Management Deadlocks:</strong> Where a management
                decision cannot be agreed upon, we recommend that the members
                agree to work in good faith to resolve any dispute and to submit
                any deadlock to a neutral independent party with applicable
                expertise. The decision can also be put to a vote of the members
                (this doesn't work in a 50/50 owner setup). There are other
                deadlock options, e.g. a forced buy-sell or liquidation of the
                business, but this can cause unintended consequences and we
                don't recommend those options.
              </p>
              <div className="mb-3">
                <label className="form-label">
                  Confirm that all the listed members will be participating in
                  the management of the company.
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="allMemberAreParticipatingInTheManagement"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes, all members will be participating in running the
                    business
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="allMemberAreParticipatingInTheManagement"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    No, one or more members are not expected to have management
                    authority
                  </label>
                </div>
                <ErrorMessage
                  name="allMemberAreParticipatingInTheManagement"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
              {formik.values.allMemberAreParticipatingInTheManagement ===
                "false" && (
                <div className="mb-3">
                  <label className="form-label">
                    Will the non-managing member(s) still be providing services
                    to the company?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="nonManagingMemberStillBeProvidingServices"
                      className="form-check-input"
                      value="true"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="nonManagingMemberStillBeProvidingServices"
                      className="form-check-input"
                      value="false"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">No</label>
                  </div>
                  <ErrorMessage
                    name="nonManagingMemberStillBeProvidingServices"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    By default, each member has the full right to make decisions
                    on behalf of the LLC. If this is not intended to be the
                    case, then special provisions may need to be added. Based on
                    your answers to this quetion, we may need to have a
                    follow-up discussion to ensure this LLC Builder tool can
                    address your LLC set. Please continue to complete the form,
                    regardless.
                  </span>
                </div>
              )}
              {formik.values.allMemberAreParticipatingInTheManagement ===
                "false" && (
                <div className="mb-3">
                  <label className="form-label">
                    Which members are not expected to have manager authority?
                    <span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="membersNotExpectedToHaveManagerAuthority"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="membersNotExpectedToHaveManagerAuthority"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>Please just write in each applicable name.</span>
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">
                  What will be each member's expected time commitment?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="expectedTimeCommitment[0]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Full-Time
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="expectedTimeCommitment[1]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Part-Time</label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="expectedTimeCommitment[2]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Just as reasonably needed to run the company
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="expectedTimeCommitment[3]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Other </label>
                </div>
                <Field
                  type="text"
                  name="otherEachMemberExpectedTimeCommitment"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="expectedTimeCommitment"
                  component="div"
                  style={{ color: "red" }}
                />
                <ErrorMessage
                  name="otherEachMemberExpectedTimeCommitment"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  Use the other option if the members will have different time
                  commitments. Please describe as applicable.
                </span>
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Will members get a salary?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="memberGetSalary"
                    className="form-check-input"
                    value="1"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    No, members will only get profit distributions as members
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="memberGetSalary"
                    className="form-check-input"
                    value="2"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Yes, reasonable compensation for a similar company and level
                    of development to be set by the members each year
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="memberGetSalary"
                    className="form-check-input"
                    value="3"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Other</label>
                </div>
                <Field
                  type="text"
                  name="otherMemberGetSalary"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="memberGetSalary"
                  component="div"
                  style={{ color: "red" }}
                />
                <ErrorMessage
                  name="otherMemberGetSalary"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  Situations can vary, however, it is often advisable to have
                  members paid a salary, rather than just share in profit
                  distributions. The actual amount can be set by the members at
                  any time, but the Operating Agreement should specify the
                  expectation.
                </span>
              </div>
              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true") ||
                formik.values.allMemberAreParticipatingInTheManagement ===
                  "true") && (
                <>
                  <p>
                    <strong>Co-Member Approval Rights:</strong> Since there are
                    more than one member with rights to make decisions for the
                    company, we recommend having certain company decisions
                    require at least two members to approve. Otherwise, by
                    default each member would have full authority necessary to
                    take any actions on behalf of the company. Our standard
                    terms would create a set of decisions that require at least
                    a majority of members (by person or ownership %) to approve.
                  </p>
                  <p>
                    If there are only two members, then this does require both
                    members to agree, which raises the risk of deadlock. Where
                    there are three or more members, before selecting unanimous
                    approval consideration should be given to whether you truly
                    want unanimous approval as it gives each member a veto
                    right. In actual practice you may seek unanimous approval
                    for big decisions, but it may not be best to legally require
                    that in the operating agreement.
                  </p>
                </>
              )}
              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true") ||
                formik.values.allMemberAreParticipatingInTheManagement ===
                  "true") && (
                <div className="mb-3">
                  <label className="form-label">
                    Would you like to have co-member approval rights?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="isCoMemberHaveApprovalRight"
                      className="form-check-input"
                      value="true"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="isCoMemberHaveApprovalRight"
                      className="form-check-input"
                      value="false"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">No</label>
                  </div>
                  <ErrorMessage
                    name="isCoMemberHaveApprovalRight"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}
              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true" &&
                formik.values.isCoMemberHaveApprovalRight === "true") ||
                (formik.values.allMemberAreParticipatingInTheManagement ===
                  "true" &&
                  formik.values.isCoMemberHaveApprovalRight === "true")) && (
                <div className="mb-3">
                  <label className="form-label">
                    What co-member approval threshold do you want?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="coMemberApprovalThreshold"
                      className="form-check-input"
                      value="1"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Majority of members (by person)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="coMemberApprovalThreshold"
                      className="form-check-input"
                      value="2"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Majority of members (by ownership %)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="coMemberApprovalThreshold"
                      className="form-check-input"
                      value="3"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Unanimous, all members
                    </label>
                  </div>
                  <ErrorMessage
                    name="coMemberApprovalThreshold"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    We recommend a majority (by person) in most cases and
                    disfavor unanimous approval. If only two members, a majority
                    does require both, but we still recommend selecting a
                    majority (by person).
                  </span>
                </div>
              )}
              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true" &&
                formik.values.isCoMemberHaveApprovalRight === "true") ||
                (formik.values.allMemberAreParticipatingInTheManagement ===
                  "true" &&
                  formik.values.isCoMemberHaveApprovalRight === "true")) && (
                <div className="mb-3">
                  <label className="form-label">
                    Co-member approval required to:
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[0]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Enter into any transaction or contract above [dollar limit
                      set below], other than standard customer engagements.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[1]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Enter into any customer engagements with an expected
                      annual contract value in excess of an certain threshold or
                      that materially deviate from the company's standard terms,
                      or that would impose substantial financial or resource
                      burdens on the company outside of the company's ordinary
                      course of business.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[2]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Approve distribution of any profits or retained earnings.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[3]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Set the amount and terms of any member salary/compensation
                      or enter into any other agreement that would have a direct
                      material financial benefit to a member (or a member’s
                      affiliate or family member), provided the the vote of the
                      interested member will not count in any majority approval
                      if there are more than two members
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[4]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Appoint or remove any officers of the company.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[5]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Hire or terminate any employee.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[6]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Issue any new Units or admit any new members.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[7]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Approve the transfer of any Units (except other permitted
                      transfer - see questions below).
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[8]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Change the bank account or open any new bank account in
                      the name of the company.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[9]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Sign a new lease (or any material amendment to a lease) or
                      make any binding engagement with respect to any location
                      for the business.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[10]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Approve a sale of the company (or substantially all its
                      assets).
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[11]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      File or settle any lawsuit.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[12]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Dissolve, liquidate, or wind up of the LLC, or the file
                      for a voluntary petition for bankruptcy.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[13]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Take any other material action outside of the usual course
                      of the Company’s business.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[14]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Amend the Operating Agreement (which would be in addition
                      to majority of members)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="coMemberApproval[15]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">Other </label>
                  </div>
                  <Field
                    type="text"
                    name="otherCoMemberApprovalRequiredTo"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="coMemberApproval"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <ErrorMessage
                    name="otherCoMemberApprovalRequiredTo"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}

              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true" &&
                formik.values.isCoMemberHaveApprovalRight === "true" &&
                formik.values.coMemberApproval[0]) ||
                (formik.values.allMemberAreParticipatingInTheManagement ===
                  "true" &&
                  formik.values.isCoMemberHaveApprovalRight === "true" &&
                  formik.values.coMemberApproval[0])) && (
                <div className="mb-3">
                  <label className="form-label">
                    What should be the dollar limit on transactions before
                    co-member approval is required?<span>*</span>
                  </label>
                  <div className="d-flex align-items-center">
                    <span className="me-2">$</span>
                    <Field
                      type="text"
                      name="limitOnTransactionsBeforeCoMemberApprovalIsRequired"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                  </div>
                  <ErrorMessage
                    name="limitOnTransactionsBeforeCoMemberApprovalIsRequired"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}
              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true" &&
                formik.values.isCoMemberHaveApprovalRight === "true" &&
                formik.values.isEnterIntoAnyCustomerEngagements &&
                formik.values.coMemberApproval[1]) ||
                (formik.values.allMemberAreParticipatingInTheManagement ===
                  "true" &&
                  formik.values.isCoMemberHaveApprovalRight === "true"  &&
                  formik.values.coMemberApproval[1])) && (
                <div className="mb-3">
                  <label className="form-label">
                    What should be the dollar limit on customer engagement
                    transactions before co-member approval is required?
                    <span>*</span>
                  </label>
                  <div className="d-flex align-items-center">
                    <span className="me-2">$</span>
                    <Field
                      type="text"
                      name="limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                  </div>
                  <ErrorMessage
                    name="limitOnCustomerEngagementTransactionsBeforeCoMemberApprovalIsRequired"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}
              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true" &&
                formik.values.isCoMemberHaveApprovalRight === "true") ||
                (formik.values.allMemberAreParticipatingInTheManagement ===
                  "true" &&
                  formik.values.isCoMemberHaveApprovalRight === "true")) && (
                <p>
                  <strong>Management Deadlock:</strong> Where there are an even
                  number of members, or any circumstance where unanimous
                  approval is required (which we don't recommend), a deadlock
                  can result.
                </p>
              )}
              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true" &&
                formik.values.isCoMemberHaveApprovalRight === "true") ||
                (formik.values.allMemberAreParticipatingInTheManagement ===
                  "true" &&
                  formik.values.isCoMemberHaveApprovalRight === "true")) && (
                <div className="mb-3">
                  <label className="form-label">
                    Would you like to include management deadlock procedures?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="isIncludeManagementDeadlockProcedures"
                      className="form-check-input"
                      value="true"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="isIncludeManagementDeadlockProcedures"
                      className="form-check-input"
                      value="false"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">No</label>
                  </div>
                  <ErrorMessage
                    name="isIncludeManagementDeadlockProcedures"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}
              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true" &&
                formik.values.isCoMemberHaveApprovalRight === "true" &&
                formik.values.isIncludeManagementDeadlockProcedures ===
                  "true") ||
                (formik.values.allMemberAreParticipatingInTheManagement ===
                  "true" &&
                  formik.values.isCoMemberHaveApprovalRight === "true" &&
                  formik.values.isIncludeManagementDeadlockProcedures ===
                    "true")) && (
                <div className="mb-3">
                  <label className="form-label">
                    Which management deadlock resolution would you like?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="managementDeadlockResolutionYouLike"
                      className="form-check-input"
                      value="1"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Use mediation and submit to independent expert if you
                      can't reach a resolution
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="managementDeadlockResolutionYouLike"
                      className="form-check-input"
                      value="2"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Submit for approval by a vote of the members
                    </label>
                  </div>
                  <span>
                    if there are two 50% owners, submitting to the members
                    should not be selected.
                  </span>
                </div>
              )}
              {((formik.values.allMemberAreParticipatingInTheManagement ===
                "false" &&
                formik.values.nonManagingMemberStillBeProvidingServices ===
                  "true" &&
                formik.values.isCoMemberHaveApprovalRight === "true" &&
                formik.values.isIncludeManagementDeadlockProcedures ===
                  "true" &&
                formik.values.managementDeadlockResolutionYouLike === "2") ||
                (formik.values.allMemberAreParticipatingInTheManagement ===
                  "true" &&
                  formik.values.isCoMemberHaveApprovalRight === "true" &&
                  formik.values.isIncludeManagementDeadlockProcedures ===
                    "true" &&
                  formik.values.managementDeadlockResolutionYouLike ===
                    "2")) && (
                <div className="mb-3">
                  <label className="form-label">
                    Deadlock vote threshold of the members
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="deadlockVoteThreshold"
                      className="form-check-input"
                      value="1"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Majority of members by percentage interest
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="deadlockVoteThreshold"
                      className="form-check-input"
                      value="2"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Two-Thirds of members by percentage interest
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="deadlockVoteThreshold"
                      className="form-check-input"
                      value="3"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      75% of members by percentage interest (make sure this
                      works given breakdown of ownership)
                    </label>
                  </div>
                  <ErrorMessage
                    name="deadlockVoteThreshold"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}
              <p>
                <strong>Member Removal:</strong> In a manager-managed LLC, by
                default a member can not be removed by a vote of the other
                members and any right to remove a member must be in the
                operating agreement. The two primary options to allow for
                removing a member is removal for cause and removal without
                cause. Generally, "cause" are such things as the conviction of a
                felony, fraud, continued failure to perform duties, or willful
                bad faith actions that damage to the company (not just mistakes
                though). You may also decide to have the option to remove
                without cause for any reason. Selecting the right terms for
                removal involves considering the ownership % of the different
                members and if you want the absolute right to remove a member
                who might not have done anything justifying "cause" but just
                isn't working out anymore (this tends to be more appropriate in
                3 and 4 person LLCs).
              </p>
              <p>
                <strong>Explanatory Note:</strong> When there are two equal
                members removal is difficult and there is no great way to avoid
                disputes. It's generally recommended to include some grounds for
                removal, so that there is a clear basis on which to submit
                disputes to mediation/arbitration.
              </p>
              <p>
                <strong>Effect of Removal for Cause:</strong> A member removed
                for cause will be dissociated as a member and their units would
                generally be subject to repurchase by the company (see section
                on company repurchases below).
              </p>
              <div className="mb-3">
                <label className="form-label">
                  Should a member be able to be removed for any reason or only
                  for cause/incapacity?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="shouldMemberAbleToBeRemoved"
                    className="form-check-input"
                    value="1"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Only allow removal of a member for cause or incapacity
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="shouldMemberAbleToBeRemoved"
                    className="form-check-input"
                    value="2"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Allow a member to be removed with or without cause or for
                    any reason
                  </label>
                </div>
                <ErrorMessage
                  name="shouldMemberAbleToBeRemoved"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
              {formik.values.shouldMemberAbleToBeRemoved === "1" && (
                <div className="mb-3">
                  <label className="form-label">
                    What vote threshold do you want to remove a member for cause
                    or incapacity?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveForCauseOrIncapacity"
                      className="form-check-input"
                      value="1"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Majority
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveForCauseOrIncapacity"
                      className="form-check-input"
                      value="2"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Super Majority (66 2/3 %)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveForCauseOrIncapacity"
                      className="form-check-input"
                      value="3"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Super Super Majority (75%)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveForCauseOrIncapacity"
                      className="form-check-input"
                      value="4"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      The sole other member in a 50/50 ownership set-up
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveForCauseOrIncapacity"
                      className="form-check-input"
                      value="5"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      All members other than the manager being removed
                      (regardless of percentage)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveForCauseOrIncapacity"
                      className="form-check-input"
                      value="6"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">Other</label>
                  </div>
                  <Field
                    type="text"
                    name="otherVoteThresholdYouWantToRemoveForCauseOrIncapacity"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="voteThresholdYouWantToRemoveForCauseOrIncapacity"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <ErrorMessage
                    name="otherVoteThresholdYouWantToRemoveForCauseOrIncapacity"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}
              {formik.values.shouldMemberAbleToBeRemoved === "2" && (
                <div className="mb-3">
                  <label className="form-label">
                    What vote threshold do you want to remove a member without
                    cause?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveWithoutCause"
                      className="form-check-input"
                      value="1"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Majority
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveWithoutCause"
                      className="form-check-input"
                      value="2"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Super Majority (66 2/3 %)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveWithoutCause"
                      className="form-check-input"
                      value="3"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Super Super Majority (75%)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveWithoutCause"
                      className="form-check-input"
                      value="4"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      All members other than the manager being removed
                      (regardless of percentage)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="voteThresholdYouWantToRemoveWithoutCause"
                      className="form-check-input"
                      value="5"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">Other</label>
                  </div>
                  <Field
                    type="text"
                    name="otherVoteThresholdYouWantToRemoveWithoutCause"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="voteThresholdYouWantToRemoveWithoutCause"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <ErrorMessage
                    name="otherVoteThresholdYouWantToRemoveWithoutCause"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}
              <p>
                <strong>Member Resignation:</strong> Upon resignation of a
                member, unvested units will be forfeited. Additionally, you may
                elect to have any vested units subject to repurchase by the
                company when a member resigns. In some cases, business partners
                prefer that if one of the members steps down from the company
                they should be able to keep any vested units and not subject to
                any forced sale any vested units. Keep in mind that if everyone
                agrees at the time of resignation, the resigning member can keep
                or sell back any units as agreed. The decision here is whether
                to give the company the right, but not the obligation, to
                buy-out a resigning member.
              </p>
              <div className="mb-3">
                <label className="form-label">
                  Upon a resignation, should the member's units be subject to
                  repurchase by the Company?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="shouldTheMemberUnitSubjectToRepurchase"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes, the company should have the option to buy-out the
                    resigning member.
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="shouldTheMemberUnitSubjectToRepurchase"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    No, a resigning member should not be subject to a forced
                    buy-out
                  </label>
                </div>
                <ErrorMessage
                  name="shouldTheMemberUnitSubjectToRepurchase"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  Note: This would apply only to "vested" units, if vesting
                  applies. See question below on the company's repurchase right
                  that should align with your answer to this question.
                </span>
              </div>
              <div className="mb-3">
                <label className="form-label">
                  How long of a notice period would you like for a member
                  resignation?*
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howLongOfNoticePeriod"
                    className="form-check-input"
                    value="1"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    30 days
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howLongOfNoticePeriod"
                    className="form-check-input"
                    value="2"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">60 days</label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howLongOfNoticePeriod"
                    className="form-check-input"
                    value="3"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">90 days</label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howLongOfNoticePeriod"
                    className="form-check-input"
                    value="4"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">120 days</label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howLongOfNoticePeriod"
                    className="form-check-input"
                    value="5"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Other</label>
                </div>
                <Field
                  type="text"
                  name="otherHowLongOfNoticePeriod"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="howLongOfNoticePeriod"
                  component="div"
                  style={{ color: "red" }}
                />
                <ErrorMessage
                  name="otherHowLongOfNoticePeriod"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  Suggestion: The period should be long enough to help not leave
                  the company in too much of tough spot.
                </span>
              </div>
              <p>
                <strong>Fiduciary Duties:</strong> Members have certain
                fiduciary duties to act in good faith and in the best interest
                of the company and other members. You may decide to waive these
                fiduciary duties to the extent permitted by law. Under
                Washington's LLC Act, liability may not be limited for
                intentional misconduct, knowing violations of law, improper
                distributions, or where the manager received a benefit they were
                not entitled to. A member's duty of good faith and faith dealing
                also cannot be waived.
              </p>
              <p>
                <strong>Suggestion:</strong> We typically recommend that general
                fiduciary duties are waived to the extent permitted, so the the
                member's duties are more clearly bound by just what is in the
                operating agreement.
              </p>
              <div className="mb-3">
                <label className="form-label">
                  Would you like to waive the members' fiduciary duties to the
                  company and other members to the extent permitted by law?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="isLikeToWaiveTheMemberFiduciaryDuties"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="isLikeToWaiveTheMemberFiduciaryDuties"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">No</label>
                </div>
                <ErrorMessage
                  name="isLikeToWaiveTheMemberFiduciaryDuties"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Do you want the members to be subject to a non-compete
                  agreement with the company?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="isMemberSubjectToNonCompeteAgreement"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="isMemberSubjectToNonCompeteAgreement"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">No</label>
                </div>
                <ErrorMessage
                  name="isMemberSubjectToNonCompeteAgreement"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  If selected the non-compete will apply for the term you decide
                  in a geographic area where the company conducts business.
                </span>
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Do you want the members to be subject to a non-solicitation
                  agreement with the company?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="isMemberSubjectToNonSolicitationAgreement"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="isMemberSubjectToNonSolicitationAgreement"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">No</label>
                </div>
                <span>
                  A non-solicitation provision would prevent a member from
                  trying to take any of the company's current customers or hire
                  away any employees or contractors of the company.
                </span>
              </div>

              {formik.values.isMemberSubjectToNonSolicitationAgreement ===
                "false" &&
                formik.values.isMemberSubjectToNonCompeteAgreement ===
                  "true" && (
                  <div className="mb-3">
                    <label className="form-label">
                      How many months after a member is no longer working for
                      the company do you want the non-compete to last?
                      <span>*</span>
                    </label>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonCompete"
                        className="form-check-input"
                        value="1"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label" for="flexRadioDefault1">
                        12 Months
                      </label>
                    </div>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonCompete"
                        className="form-check-input"
                        value="2"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label">18 Months</label>
                    </div>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonCompete"
                        className="form-check-input"
                        value="3"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label">24 Months</label>
                    </div>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonCompete"
                        className="form-check-input"
                        value="4"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label">Other</label>
                    </div>
                    <Field
                      type="text"
                      name="otherMonthsAfterMemberNoLongerWorkingForNonCompete"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="monthsAfterMemberNoLongerWorkingForNonCompete"
                      component="div"
                      style={{ color: "red" }}
                    />
                    <ErrorMessage
                      name="otherMonthsAfterMemberNoLongerWorkingForNonCompete"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>
                )}

              {formik.values.isMemberSubjectToNonSolicitationAgreement ===
                "true" &&
                formik.values.isMemberSubjectToNonCompeteAgreement ===
                  "false" && (
                  <div className="mb-3">
                    <label className="form-label">
                      How many months after a member is no longer working for
                      the company do you want the non-solicitation restriction
                      to last?
                      <span>*</span>
                    </label>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonSolicitation"
                        className="form-check-input"
                        value="1"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label" for="flexRadioDefault1">
                        12 Months
                      </label>
                    </div>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonSolicitation"
                        className="form-check-input"
                        value="2"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label">18 Months</label>
                    </div>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonSolicitation"
                        className="form-check-input"
                        value="3"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label">24 Months</label>
                    </div>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonSolicitation"
                        className="form-check-input"
                        value="4"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label">Other</label>
                    </div>
                    <Field
                      type="text"
                      name="otherMonthsAfterMemberNoLongerWorkingForNonSolicitation"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="monthsAfterMemberNoLongerWorkingForNonSolicitation"
                      component="div"
                      style={{ color: "red" }}
                    />
                    <ErrorMessage
                      name="otherMonthsAfterMemberNoLongerWorkingForNonSolicitation"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>
                )}
              {formik.values.isMemberSubjectToNonSolicitationAgreement ===
                "true" &&
                formik.values.isMemberSubjectToNonCompeteAgreement ===
                  "true" && (
                  <div className="mb-3">
                    <label className="form-label">
                      How many months after a member is no longer working for
                      the company do you want the non-compete and
                      non-solicitation restrictions to last?*
                      <span>*</span>
                    </label>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation"
                        className="form-check-input"
                        value="1"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label" for="flexRadioDefault1">
                        12 Months
                      </label>
                    </div>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation"
                        className="form-check-input"
                        value="2"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label">18 Months</label>
                    </div>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation"
                        className="form-check-input"
                        value="3"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label">24 Months</label>
                    </div>
                    <div className="form-check">
                      <Field
                        type="radio"
                        name="monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation"
                        className="form-check-input"
                        value="4"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <label className="form-check-label">Other</label>
                    </div>
                    <Field
                      type="text"
                      name="otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="monthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation"
                      component="div"
                      style={{ color: "red" }}
                    />
                    <ErrorMessage
                      name="otherMonthsAfterMemberNoLongerWorkingForNonCompeteAndNonSolicitation"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>
                )}
            </div>

            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn-submit-secondary me-2 rounded pe-3 d-flex align-items-center"
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(setStep(1));
                }}
              >
                <i className="fa-solid fa-arrow-left mx-2"></i>PREVIOUS
              </button>
              <button
                type="submit"
                className="submit-button ps-3 d-flex align-items-center"
                onClick={()=>{console.log(formik)}}
              >
                NEXT<i className="ms-2 fa-solid fa-arrow-right "></i>
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default MultiMemberLLCFormStep2;
